
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinmoshi() {



    const cardData =
    {
        keyword: 'Cab Service in Moshi',
        heading: 'Platinum24 Cabs: Cab Service in Moshi',
        headingDescription: ' Platinum24 Cabs offers dependable Cab Service in Moshi, providing safe and comfortable travel options for daily commutes, airport transfers, outstation trips, and business travel. Our fleet includes hatchbacks, sedans, SUVs, and luxury cars, all well-maintained to deliver a smooth ride for individuals, families, and corporate clients. With professional drivers, transparent pricing, and punctual pickups, we ensure every journey is stress-free. Whether you need a quick city drop or a long-distance cab, Platinum24 Cabs guarantees reliable service and complete customer satisfaction across Moshi and surrounding areas.',

        top: 'Top Places to Visit in Pune with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas, Shaniwar Wada is Pune’s most iconic fort palace. It was once the seat of the Maratha Empire and still echoes the legacy of Bajirao and Mastani. Its mighty Delhi Gate, fountains, and expansive gardens attract thousands of visitors. Though destroyed by fire in 1828, the ruins still retain grandeur. The evening light-and-sound show recreates Maratha history. Shaniwar Wada is Pune’s proud heritage landmark."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, constructed in 1892, is a majestic monument tied to India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. Today, it serves as a museum displaying Gandhi’s personal belongings and photographs. Its sprawling lawns and Italian arches add to the charm. It is also the resting place of Kasturba Gandhi. Aga Khan Palace is Pune’s historical gem of inspiration."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, located 25 km from Pune, is renowned for the 1670 battle where Tanaji Malusare sacrificed his life for Chhatrapati Shivaji Maharaj. The fort sits atop a hill offering trekking trails and panoramic Sahyadri views. Visitors explore its bastions, memorials, and temples reflecting Maratha valor. Monsoon adds mist, waterfalls, and greenery. Local villagers serve rustic pithla-bhakri meals. Sinhagad is Pune’s perfect mix of history, trekking, and nature."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine dedicated to Lord Ganesha. The idol, adorned with gold and ornaments, attracts lakhs of devotees annually. During Ganesh Chaturthi, the temple becomes the epicenter of grand festivities. It is also known for charitable and cultural activities. The spiritual aura here draws devotees and tourists alike. Dagdusheth Ganpati is Pune’s divine cultural heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple, carved in the 8th century, is a rock-cut shrine dedicated to Lord Shiva. The site features a sanctum, massive stone pillars, and a Nandi mandapa. Despite being in the city’s center, it offers peace and a spiritual retreat. Evening chants enhance the mystical ambiance. Its carvings showcase early Indian rock-cut craftsmanship. Pataleshwar is Pune’s hidden heritage gem."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a treasure trove with over 20,000 artifacts collected by Dr. Dinkar Kelkar. The collection includes ornaments, sculptures, musical instruments, and antiques of daily life. The recreated Mastani Mahal is the highlight for visitors. Students and history enthusiasts find it fascinating and educational. It preserves centuries of cultural heritage. The museum is Pune’s proud showcase of art and tradition."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest landmarks, offers panoramic views of the city. The hilltop houses the Parvati Temple dedicated to Lord Shiva and Goddess Parvati, built during the Peshwa era. Visitors climb 103 steps to reach the shrine, blending devotion with adventure. Smaller shrines and a museum add cultural depth. Sunrises and sunsets from here are breathtaking. Parvati Hill is Pune’s sacred and scenic retreat."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is Pune’s global hub of wellness and spirituality. Spread across serene gardens, it offers meditation, yoga, and personal growth workshops. Zen-inspired landscapes and modern facilities attract seekers worldwide. Visitors experience rejuvenation, peace, and mindfulness here. It is a unique blend of spirituality and modern lifestyle. Osho Ashram is Pune’s international retreat of tranquility."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, modeled after Japan’s Korakuen Garden, is Pune’s largest landscaped park. It features flowing streams, stone bridges, and manicured lawns. Families and couples enjoy peaceful walks, picnics, and photography here. Seasonal flowers add charm throughout the year. The garden reflects Indo-Japanese cultural ties. Pu La Deshpande Garden is Pune’s lush green paradise."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular weekend getaway near Pune. It supplies water to the city while offering scenic landscapes. Monsoon turns it into a picturesque spot with overflowing waters. Vendors selling hot corn and tea add to the charm. It also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s refreshing natural retreat."
  }
],


   "services": [
    {
      "name": "Moshi Cab Service",
      "description": "Discover reliable and comfortable transportation options with our Moshi Cab Service. Designed to cater to residents and visitors alike, our service guarantees clean, well-maintained vehicles equipped with modern amenities. Whether you need a quick ride across town or a longer journey, our professional drivers prioritize your safety and punctuality. With transparent pricing and easy booking options, you can plan your travel hassle-free. Plus, our 24/7 customer support is always available to assist you with any queries or last-minute changes, ensuring a seamless travel experience every time."
    },
    {
      "name": "Taxi Service Moshi",
      "description": "Our Taxi Service in Moshi is the perfect solution for all your local and outstation travel needs. We pride ourselves on offering a diverse fleet of vehicles, ranging from economical hatchbacks to spacious SUVs, accommodating solo travelers, families, and groups of all sizes. Each ride is driven by courteous, experienced chauffeurs who are familiar with the local routes and traffic patterns, ensuring timely arrivals and smooth rides. Whether it's a daily commute, airport transfer, or a leisurely city tour, our service combines affordability with reliability, backed by real-time GPS tracking and a customer-friendly booking platform."
    },
    {
      "name": "Moshi Local Taxi",
      "description": "For quick and convenient rides within the city, our Moshi Local Taxi service is unmatched. Perfect for running errands, attending meetings, or exploring local attractions, our taxis offer a stress-free way to get around. Drivers are knowledgeable about the best routes and shortcuts, helping you avoid traffic jams and reach your destination promptly. With affordable fare structures, transparent billing, and well-maintained vehicles equipped with comfortable seating and climate control, you can relax and enjoy your journey. Additionally, our easy-to-use app and hotline make booking a breeze anytime, anywhere."
    },
    {
      "name": "Affordable Taxi Moshi",
      "description": "Travel smart with our Affordable Taxi Moshi service, crafted specifically for budget-conscious customers who don’t want to compromise on quality. Our fleet includes fuel-efficient cars that offer excellent mileage without sacrificing comfort or safety. Whether you need a taxi for a short trip or an extended journey, we provide flexible rental plans and transparent pricing with no hidden charges. Take advantage of special discounts, promotional offers, and loyalty rewards that make every ride even more economical. Experience dependable transportation without breaking the bank, backed by professional drivers committed to your satisfaction."
    },
    {
      "name": "Moshi Taxi with Driver",
      "description": "Enjoy a premium travel experience with our Moshi Taxi with Driver service, designed for those who prefer to relax and let a professional handle the driving. Our drivers are extensively trained, courteous, and knowledgeable about local landmarks and routes, ensuring a safe and efficient journey. Ideal for business travelers, tourists, families, and elderly passengers, this service provides convenience and peace of mind. Vehicles are thoroughly cleaned and sanitized before every trip, and drivers adhere to strict safety protocols. Whether you need hourly service or a full-day package, our driver services guarantee punctuality, comfort, and a stress-free travel experience."
    },
    {
      "name": "Moshi Airport Taxi",
      "description": "Never miss a flight with our dependable Moshi Airport Taxi service, offering timely pickups and drop-offs to and from Pune Airport and other nearby terminals. Our drivers monitor flight statuses in real-time to adjust schedules as needed, minimizing wait times and ensuring punctual arrivals. Enjoy the convenience of fixed fares with no surprises, spacious luggage-friendly vehicles, and friendly customer service. Whether you’re traveling solo or in a group, our airport taxi service prioritizes comfort, safety, and reliability, making your journey to or from the airport as smooth as possible."
    },
    {
      "name": "Cab Rental Moshi",
      "description": "Looking for a flexible and hassle-free way to rent a cab in Moshi? Our Cab Rental Moshi service offers a wide range of vehicles to suit your travel needs — from compact cars for city driving to larger SUVs for family trips or group outings. Rentals can be booked hourly, daily, or for extended periods, with options for self-drive or chauffeur-driven cars. All vehicles undergo regular maintenance and sanitization for your safety. With transparent pricing, easy online booking, and responsive customer support, renting a cab in Moshi has never been easier or more convenient."
    },
    {
      "name": "Moshi Outstation Taxi",
      "description": "Plan your next intercity journey with confidence using our Moshi Outstation Taxi service. Whether it’s a weekend getaway, business trip, or family visit, our comfortable and reliable taxis will get you there safely and on time. Our drivers are experienced in long-distance travel and familiar with highway routes and rest stops, ensuring a smooth, stress-free ride. Benefit from customizable trip packages, transparent pricing including tolls and fuel, and 24/7 support throughout your journey. Enjoy the convenience of door-to-door service that adapts to your schedule and itinerary."
    },
    {
      "name": "Moshi Corporate Taxi",
      "description": "Elevate your business travel with our Moshi Corporate Taxi service, tailored to meet the demands of professionals and companies alike. From daily employee transportation to executive rides for client meetings and events, our service combines professionalism with punctuality. Enjoy the ease of monthly invoicing, GST billing, and customizable packages that fit your company’s budget and travel needs. Our well-maintained fleet and trained drivers ensure a comfortable and safe commute, helping your team stay productive and stress-free. Dedicated account managers are also available to provide personalized support and quick response times."
    },
    {
      "name": "Moshi Taxi Deals",
      "description": "Unlock great savings with our exclusive Moshi Taxi Deals designed to make your travels affordable and rewarding. Take advantage of seasonal discounts, early booking offers, weekend specials, and referral rewards. Our transparent pricing means no hidden fees or surprises — just great value on every ride. Whether you’re planning a short local trip or a long outstation journey, these deals help you save without compromising on quality or service. Join our loyalty program to earn points and redeem additional discounts on future bookings."
    },
    {
      "name": "Moshi City Taxi",
      "description": "Explore Moshi effortlessly with our Moshi City Taxi service, perfect for both locals and visitors wanting to get around town easily. Our taxis are equipped with GPS navigation and safety features to provide a reliable and secure ride. Whether you need transportation for daily errands, sightseeing, or attending events, our friendly drivers offer courteous and professional service. Flexible booking options, competitive fares, and timely pickups make city travel stress-free and enjoyable. Plus, our customer support team is always ready to assist with any special requests or travel advice."
    },
    {
      "name": "Moshi Family Taxi Service",
      "description": "Travel together comfortably with our Moshi Family Taxi Service, offering spacious vehicles ideal for families of all sizes. Whether you’re heading to a family function, weekend outing, or sightseeing tour, our taxis provide ample room for passengers and luggage. Safety is our priority — child seats and other special accommodations are available upon request. Our friendly drivers are patient and experienced in catering to family travel needs, ensuring a pleasant journey for everyone. Booking is easy through our app or phone, with flexible scheduling and affordable rates."
    },
    {
      "name": "Taxi Booking Online Moshi",
      "description": "Simplify your travel plans with Taxi Booking Online Moshi, a user-friendly platform that lets you reserve your taxi anytime, anywhere. Choose your preferred vehicle, specify pickup and drop-off locations, and select rental durations with just a few clicks. Our secure payment gateway accepts multiple options for your convenience. Instant confirmation and real-time updates keep you informed about your ride status. Dedicated customer support is available 24/7 to help with changes, cancellations, or special requests, making taxi booking a breeze."
    },
    {
      "name": "Moshi Taxi Service 24x7",
      "description": "No matter the time or day, our Moshi Taxi Service 24x7 ensures you’re never stranded. Whether you have an early morning flight, late-night meeting, or emergency travel needs, our reliable fleet and skilled drivers are ready to serve you round the clock. We prioritize safety, punctuality, and comfort, providing fast response times and flexible booking options. Enjoy peace of mind knowing that help is just a call or click away, with constant customer support to assist you throughout your journey."
    }
  ],
  "tableData": [
    ["Moshi Cab Service", "Taxi Service Moshi"],
    ["Moshi Local Taxi", "Affordable Taxi Moshi"],
    ["Moshi Taxi with Driver", "Moshi Airport Taxi"],
    ["Cab Rental Moshi", "Moshi Outstation Taxi"],
    ["Moshi Corporate Taxi", "Moshi Taxi Deals"],
    ["Moshi City Taxi", "Moshi Family Taxi Service"],
    ["Taxi Booking Online Moshi", "Moshi Taxi Service 24x7"]
  ],


  "whychoose": [
  {
    "WhyChooseheading": "Reliable Cab Service in Moshi",
    "WhyChoosedescription": "Platinum24 Cabs offers trustworthy and affordable cab services in Moshi for all your travel needs."
  },
  {
    "WhyChooseheading": "Wide Selection of Well-Maintained Vehicles",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, and tempo travellers to match your group size and comfort."
  },
  {
    "WhyChooseheading": "Clean and Sanitized Cabs for Your Safety",
    "WhyChoosedescription": "Our vehicles are regularly cleaned and sanitized to ensure a safe and comfortable journey in Moshi."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Moshi Area",
    "WhyChoosedescription": "Professional drivers who know Moshi’s routes well for smooth and timely travel."
  },
  {
    "WhyChooseheading": "Affordable Pricing with No Hidden Charges",
    "WhyChoosedescription": "Transparent fares that cover fuel, tolls, and driver allowances for worry-free travel."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Easy Booking",
    "WhyChoosedescription": "Our dedicated support team is available around the clock to help with your cab bookings in Moshi."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages for Short and Long Term",
    "WhyChoosedescription": "Choose from hourly, daily, or long-term rental plans tailored to your travel needs."
  },
  {
    "WhyChooseheading": "Easy Online Booking and Instant Confirmation",
    "WhyChoosedescription": "Book your Moshi cab quickly and securely via our website or app with instant confirmation."
  }
]














    }

const faqData = [
    {
        question: 'Does Platinum24 Cabs offer cab services in Moshi?',
        answer: 'Yes, Platinum24 Cabs provides reliable and efficient cab services in Moshi for all your travel needs.',
    },
    {
        question: 'How can I book a cab service in Moshi with Platinum24 Cabs?',
        answer: 'You can easily book your cab through our website, mobile app, or by contacting our 24x7 customer support.',
    },
    {
        question: 'What types of vehicles are available for cab service in Moshi?',
        answer: 'We offer a variety of vehicles including hatchbacks, sedans, SUVs, and luxury cars to suit your preferences.',
    },
    {
        question: 'Can I use the cab service in Moshi for local and outstation travel?',
        answer: 'Yes, Platinum24 Cabs offers cab services for both local trips within Moshi and outstation travel.',
    },
    {
        question: 'Are the drivers experienced and familiar with Moshi routes?',
        answer: 'Absolutely, our drivers are professional, licensed, and knowledgeable about Moshi and nearby areas.',
    },
    {
        question: 'Is hourly and daily cab service available in Moshi?',
        answer: 'Yes, we provide flexible hourly and daily cab packages tailored to your travel plans.',
    },
    {
        question: 'Are safety and hygiene protocols followed for cabs in Moshi?',
        answer: 'All vehicles are regularly sanitized, and drivers follow strict safety measures to ensure passenger safety.',
    },
    {
        question: 'Is cab service in Moshi available 24x7?',
        answer: 'Yes, Platinum24 Cabs offers 24x7 cab booking and services in Moshi.',
    },
    {
        question: 'What payment options are accepted for cab bookings in Moshi?',
        answer: 'We accept cash, digital wallets, UPI, and card payments for seamless transactions.',
    },
    {
        question: 'Can I customize pickup and drop-off locations within Moshi for cab service?',
        answer: 'Yes, you can specify your preferred pickup and drop-off points within Moshi as per your travel plans.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Rohit Shinde',
        feedback: 'Platinum24 Cabs provided excellent and timely cab service in Moshi. Highly recommended!',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Anjali Kulkarni',
        feedback: 'Comfortable rides and professional drivers made my trips in Moshi hassle-free.',
        rating: 5,
    },
];





































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];








const nigdiCabServiceSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Platinum24 Cabs",
  "url": "https://www.platinum24cab.com",
  "description": "Reliable and affordable cab service in Nigdi offering local taxi, airport transfers, outstation cabs, corporate taxi, and family taxi services with driver.",
  "areaServed": {
    "@type": "Place",
    "name": "Nigdi, Pune"
  },
  "serviceType": [
    "Nigdi Cab Service",
    "Taxi Service Nigdi",
    "Nigdi Local Taxi",
    "Affordable Taxi Nigdi",
    "Nigdi Taxi with Driver",
    "Nigdi Airport Taxi",
    "Cab Rental Nigdi",
    "Nigdi Outstation Taxi",
    "Nigdi Corporate Taxi",
    "Nigdi Taxi Deals",
    "Nigdi City Taxi",
    "Nigdi Family Taxi Service",
    "Taxi Booking Online Nigdi",
    "Nigdi Taxi Service 24x7"
  ],
  "telephone": "+91-XXXXXXXXXX"
};








    return (
        <div>

<Helmet>
  <title>Cab Service in Nigdi | Affordable Taxi Service Nigdi Pune</title>
  <meta
    name="description"
    content="Reliable and affordable cab service in Nigdi offering local taxi, airport transfers, outstation cabs, corporate taxi, and family taxi services with driver."
  />
  <meta
    name="keywords"
    content="Nigdi Cab Service, Taxi Service Nigdi, Nigdi Local Taxi, Affordable Taxi Nigdi, Nigdi Taxi with Driver, Nigdi Airport Taxi, Cab Rental Nigdi, Nigdi Outstation Taxi, Nigdi Corporate Taxi, Nigdi Taxi Deals, Nigdi City Taxi, Nigdi Family Taxi Service, Taxi Booking Online Nigdi, Nigdi Taxi Service 24x7"
  />
  <script type="application/ld+json">
    {JSON.stringify(nigdiCabServiceSchema)}
  </script>
</Helmet>

            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/83.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Cabserviceinmoshi;